import myaccountModule from '../scripts/myaccount/myaccount.module.js';
import appDependency from '../scripts/appDependency.js';
appDependency.addItem(myaccountModule);